import { ConfigPSIM } from "app/models/configpsim.model";
import { Observable } from "rxjs";

export abstract class AbStepConfigPSim {
  abstract qtdFinalizadas: number;
  abstract mostrarConfgGerais: boolean;
  abstract configPsim;
  abstract getResultadoCompleted(): number;
  abstract observableCompleted(): Observable<boolean>;
  abstract setResultadoCompleted(): Observable<any>;
  abstract setVoltarResultadoCompleted(): Observable<any>;
  abstract reiniciarContagem();
  abstract terminarContagem();
  abstract prepararConfigPsim(configPSIM: ConfigPSIM);
}